import { Navigation } from "@/components/Navigation";
import { Footer } from "@/components/Footer";
import { usePageMeta } from "@/hooks/use-page-meta";

// Sample testimonial data - you can replace this with real data
const testimonials = [
  {
    id: 1,
    name: "M.H Nasser Mohammed",
    designation: "Chartered Accountant, In this Field for past 25 Years",
    image: "/testimonials_pictures/Nasser.png"
  },
  {
    id: 2,
    name: "Farook",
    designation: "Team Lead",
    image: "/testimonials_pictures/Farook.png"
  },
  {
    id: 3,
    name: "Haseen Zarin Taj",
    designation: "Senior Vice President from Citi Bank",
    image: "/testimonials_pictures/Haseen.png"
  },
  {
    id: 4,
    name: "Mr.C. Mani",
    designation: "Retired as Asst. Manager from Indian Bank",
    image: "/testimonials_pictures/Mr_C_Mani.png"
  },
  {
    id: 5,
    name: "Mr.Prem Kumar",
    designation: "Retired as Marine Engineer",
    image: "/testimonials_pictures/Prem_Kumar.png"
  },
  {
    id: 6,
    name: "Mr.Rajendra Babu",
    designation: "President of BNI",
    image: "/testimonials_pictures/Rajendra Babu.png"
  },
  {
    id: 7,
    name: "Mr.Subramanian S K",
    designation: "Chartered Accountant",
    image: "/testimonials_pictures/Subramanian_SK.png"
  },
  {
    id: 8,
    name: "Mrs.R.Uma",
    designation: "Retired as Finance Assistant from UNDP.",
    image: "/testimonials_pictures/Uma.png"
  },
  {
    id: 9,
    name: "Mrs.Usha",
    designation: "Retired as School Teacher",
    image: "/testimonials_pictures/Usha.png"
  },
  {
    id: 10,
    name: "Mrs.V J Nalini",
    designation: "Retired as Faculty Member from IFMR",
    image: "/testimonials_pictures/VJ_Nalini.png"
  },
  {
    id: 11,
    name: "Mr.V Venkatesh",
    designation: "Retired as GM from Dangote Oil Refinery, Nigeria",
    image: "/testimonials_pictures/Venkatesh.png"
  },
  {
    id: 12,
    name: "Mr. Vidhya Shankar",
    designation: "Retired as GM from Velammal Educational Trust",
    image: "/testimonials_pictures/Vidhya Shankar.png"
  },
  {
    id: 13,
    name: "Mrs.P Vijaya",
    designation: "Homemaker",
    image: "/testimonials_pictures/Vijaya.png"
  },
  {
    id: 14,
    name: "Mr.K P Eswaran Krishnan",
    designation: "Retired as Assistant General Manager from SBI",
    image: "/testimonials_pictures/Eswaran.png"
  }
];

export default function Testimonials() {
  usePageMeta({
    title: "Testimonials - Skiline Recruitment",
    description: "Hear from our team members and professionals who have joined Skiline Recruitment. Read their experiences and success stories.",
    keywords: "testimonials, reviews, Skiline Recruitment team, employee experiences",
  });

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Navigation />

      {/* Hero Section */}
      <section className="bg-accent py-20 md:py-32">
        <div className="max-w-4xl mx-auto px-6 md:px-8 text-center space-y-8">
          <h1 className="font-serif text-5xl md:text-6xl font-bold text-foreground">
            Testimonials
          </h1>
          <p className="text-xl md:text-2xl text-muted-foreground leading-relaxed">
            Hear from our valued team members and professionals
          </p>
        </div>
      </section>

      {/* Testimonials Grid */}
      <section className="py-16 md:py-24 bg-background">
        <div className="max-w-7xl mx-auto px-6 md:px-8">
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6 md:gap-8">
            {testimonials.map((testimonial) => (
              <div key={testimonial.id} className="flex flex-col items-center text-center space-y-4 group">
                {/* Profile Image */}
                <div className="relative w-24 h-24 md:w-32 md:h-32 rounded-full overflow-hidden border-4 border-background shadow-lg group-hover:shadow-xl transition-shadow duration-300">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                
                {/* Name and Designation */}
                <div className="space-y-1">
                  <h3 className="font-semibold text-foreground text-sm md:text-base">
                    {testimonial.name}
                  </h3>
                  <p className="text-muted-foreground text-xs md:text-sm">
                    {testimonial.designation}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
